var module = angular.module('octopusApp.projects');

module.run(function (pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.Certificate.Import", function (octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canChooseRoles: true,
            canHaveChildren: function(){ return true; },
            canBeChild: true,
            hasPackages: function(action){return false;},
            summaryTemplateUrl: "areas/projects/actions/certificate_import/Octopus.Certificate.Import_summary.html",
            editTemplateUrl: "areas/projects/actions/certificate_import/Octopus.Certificate.Import_edit.html",

            preLink: function(scope) {

                scope.storeLocations = ['LocalMachine', 'CurrentUser', 'Custom User'];
                scope.storeNames = ['My', 'Root', 'CA', 'TrustedPeople', 'TrustedPublisher', 'AuthRoot', 'AddressBook', 'Other'];
                scope.model = {
                    storeLocation: null,
                    storeName: null,
                    customStoreName: null
                };

                scope.showCustomStoreUser = function() {
                    return scope.model.storeLocation === 'Custom User';
                };

                scope.showCustomStoreName = function() {
                    return scope.model.storeName === 'Other';
                };

                scope.showPrivateKeyAccess = function() {
                   return scope.model.storeLocation === 'LocalMachine';
                };

                initializeStoreLocation();
                initializeStoreName();

                if (scope.action.Properties["Octopus.Action.Certificate.PrivateKeyExportable"]=== undefined) {
                    scope.action.Properties["Octopus.Action.Certificate.PrivateKeyExportable"] = 'False';
                }

                if (!scope.action.Properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]) {
                    scope.action.Properties["Octopus.Action.Certificate.PrivateKeyAccessRules"] = "[]";
                }

                scope.resetValues = {
                    certificateVariable: scope.action.Properties["Octopus.Action.Certificate.Variable"],
                    storeLocation: scope.action.Properties["Octopus.Action.Certificate.StoreLocation"],
                    customStoreUser: scope.action.Properties["Octopus.Action.Certificate.StoreUser"],
                    storeName: scope.model.storeName,
                    customStoreName: scope.model.customStoreName,
                    privateKeyExportable: scope.action.Properties["Octopus.Action.Certificate.PrivateKeyExportable"]
                };

                // Project variables will not be available if this is a step template
                scope.projectVariablesUnavailable = function() {
                   return (!scope.project || !scope.project.Id);
                };

                scope.$watch('model.storeName', function(newVal) {
                   if (!newVal) {
                       return;
                   }

                    if (newVal !== 'Other') {
                        scope.action.Properties["Octopus.Action.Certificate.StoreName"] = newVal;
                        return;
                    }

                    scope.action.Properties["Octopus.Action.Certificate.StoreName"] = null;
                });

                scope.$watch('model.customStoreName', function (newVal) {
                    if (!newVal || scope.model.storeName !== 'Other') {
                       return;
                   }

                    scope.action.Properties["Octopus.Action.Certificate.StoreName"] = newVal;
                });

                scope.$watch('model.storeLocation', function (newVal) {
                    if (!newVal) {
                        return;
                    }

                    if (newVal === 'Custom User') {
                        scope.action.Properties["Octopus.Action.Certificate.StoreLocation"] = null;
                        return;
                    }

                    scope.action.Properties["Octopus.Action.Certificate.StoreLocation"] = newVal;
                    scope.action.Properties["Octopus.Action.Certificate.StoreUser"] = null;
                });

                function initializeStoreLocation() {
                    var currentStoreLocation = scope.action.Properties["Octopus.Action.Certificate.StoreLocation"];
                    var currentStoreUser = scope.action.Properties["Octopus.Action.Certificate.StoreUser"];

                    if (currentStoreLocation) {
                        scope.model.storeLocation = currentStoreLocation;
                    } else if (currentStoreUser) {
                       scope.model.storeLocation = 'Custom User';
                    }
                    else {
                        scope.model.storeLocation = 'LocalMachine';
                    }
                }

                function initializeStoreName() {
                    var currentStoreName = scope.action.Properties["Octopus.Action.Certificate.StoreName"];

                    if (!currentStoreName) {
                        // If this is the first time, default the store name to 'My'
                        scope.model.storeName = 'My';
                    } else if (_.contains(scope.storeNames, currentStoreName)) {
                        // If the store name has been previously set to one of the pre-defined values, then use it
                        scope.model.storeName = currentStoreName;
                    } else {
                        // Else, a custom value has been used
                        scope.model.storeName = 'Other';
                        scope.model.customStoreName = currentStoreName;
                    }
                }
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/certificate_import/Octopus.Certificate.Import.js
// module id = 4040849006618135
// module chunks = 1